import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { Team } from './classes/team';
import { TEAMS } from './mock-data/TEAMS';

import { Challenge } from './classes/challenge';
import { CHALLENGES } from './mock-data/CHALLENGES';

import { Submission } from './classes/submission';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Headers, RequestOptions } from '@angular/http';

import { Config} from './classes/config';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

//error handling.
import { catchError, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable()
export class ModelService {

  constructor( private http: HttpClient ) { }

  // private teamUrl = '../../model.php/leaderboard';
  // private challengeUrl = '../../model.php/challenges';
  // private submissionUrl = '../../model.php/submissions';

  private authUrl = 'https://challenge.sparkyh.com/model.php/authenticate/';


  private teamUrl = 'https://challenge.sparkyh.com/model.php/leaderboard';
  private challengeUrl = 'https://challenge.sparkyh.com/model.php/challenges';
  private submissionUrl = 'https://challenge.sparkyh.com/model.php/submissions';
  private leaderboardUrl = 'https://challenge.sparkyh.com/model.php/leaderboard';
  private authenticateUrl = 'https://challenge.sparkyh.com/model.php/authenticate/1234';
  private postSubmissionUrl = 'https://challenge.sparkyh.com/model.php/setSub';
  private logoutUrl = 'https://challenge.sparkyh.com/model.php/logout';

  dbTeams = [];
  tempAuthToCheck = '';

  // Don't forget to subscribe to this in the component that uses the method.
   getTeams (): Observable<Team[]> {
   console.log(this.http.get<Object>(this.leaderboardUrl).subscribe(
        data => {
        console.log(data);
        },
        err => {
        console.log("Error occured.")
        }
      )
    );
   console.log("teams");
   return this.http.get<Team[]>(this.teamUrl)
 }

 logout (): Observable<String> {
 return this.http.get<String>(this.logoutUrl);
 }

 getChallenges (): Observable<Challenge[]> {
 return this.http.get<Challenge[]>(this.challengeUrl)
 }

 getSubmissions (): Observable<Submission[]> {
 return this.http.get<Submission[]>(this.submissionUrl);
 }

 checkAuthentication(value: string): Observable<Config> {
   this.tempAuthToCheck = this.authUrl + value;
   return this.http.get<Config>(this.tempAuthToCheck);
   //console.log("Auth Checking");
 }

 postSubmission(submission: String){
  //let headers = new Headers({'Content-Type':'application/json'});
  //let options = new RequestOptions({ headers: headers, method: "post"});
  //console.log(submission);
  return this.http.post(this.postSubmissionUrl, submission)
          // .map(res => res.json())
          // .catch(this.handleError);
  }
  private handleError (error: Response) {
        console.error(error);
        return ' error';
    }


 }


  /** TEAMS heroes from the server
  getTeams (): Team[]{
    return TEAMS;
  } */

/*
/** TEAMS heroes from the server
getTeams (): Observable<Team[]> {
  return this.http.get<Team[]>(this.teamUrl)
    .pipe(
      tap(heroes => console.log(`fetched teams`)),
      catchError(this.handleError('getTeams', []))
  );
}
*/

/*
  getChallenges(): Challenge[] {
    return CHALLENGES;
  }
*/



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/model.service.ts